module.exports = __webpack_public_path__ + "img/logo_title_v2.74abb46b.png";